import {BaseEntityUnDeletable} from '../../../common/entities';

export class Feedback extends BaseEntityUnDeletable {
    description: string;
}
